import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { AddButton } from 'components/core';
import { TaxCategoryDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  addRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControl: {
    width: '230px',
    margin: '0px',
    marginRight: theme.spacing.unit*2,
  },
});

class Expense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddTaxCategory: false,
    };
  }

  render() {
    const {
      classes,
      receipt,
      showValidation,
      validation,
      taxCategories,
      handleChange
    } = this.props;
    const { showAddTaxCategory } = this.state;

    return(
      <div className={classes.root}>
        <TaxCategoryDialog
          show={showAddTaxCategory}
          handleCreated={(result) => {
            handleChange("taxCategoryId", result);
          }}
          handleClose={() => this.setState({ showAddTaxCategory: false })}
        />
        <div className={classes.addRow}>
          <FormControl
            error={(showValidation && !!validation.validateField("taxCategoryId"))}
            className={classes.formControl}
          >
            <InputLabel htmlFor="taxCategory-simple">Tax Category</InputLabel>
            <Select
              value={receipt.taxCategoryId === undefined ? "" : receipt.taxCategoryId}
              onChange={(event) => {
                handleChange("taxCategoryId", event.target.value);
              }}
              inputProps={{
                name: 'taxCategoryId',
                id: 'taxCategory-simple',
              }}
            >
              {taxCategories &&
                taxCategories.map((taxCategory, i) => {
                  return <MenuItem key={i} value={taxCategory.id}>{taxCategory.name}</MenuItem>
                })
              }
            </Select>
            {showValidation && validation.validateField("taxCategoryId") &&
               <FormHelperText>{validation.validateField("taxCategoryId")}</FormHelperText>
             }
          </FormControl>
          <AddButton
            onClick={() => this.setState({ showAddTaxCategory: true })}
          />
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const taxCategories = state.taxCategoriesState;

  return {
    taxCategories: taxCategories,
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Expense);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/Dialog/Expense.jsx